import { Fragment, useContext } from "react";
import { AccountContext } from "contexts";
import { useFormContext, useWatch } from "react-hook-form";
import moment from "moment";
import { convertNumber, useCoaByCode } from "utils";
import { PaymentBillServiceSchema } from "../schema";

export const JournalList = () => {
  return <></>;
}

const PaymentAccount = () => {
  const account = useContext(AccountContext);
  const tracking = useCoaByCode("LA07");

  const { control } = useFormContext<PaymentBillServiceSchema>();

  const coa_id = useWatch({ control, name: "coa_id" });
  const memo = useWatch({ control, name: "memo" });
  const payment_amount = useWatch({ control, name: "payment_amount" });
  const transaction_date = useWatch({ control, name: "transaction_date" });
  const trx_code = useWatch({ control, name: "trx_code" });

  const formattedDate = moment(transaction_date).format("DD/MM/YYYY");
  const coa = account.data?.find((item) => item.value === coa_id)?.label ?? "-";
  const formattedAmount = convertNumber(payment_amount).intoCurrency;

  if (coa_id && payment_amount) {
    return (
      <Fragment>
        <tr>
          <td>{formattedDate}</td>
          <td>{trx_code}</td>
          <td>{tracking.data}</td>
          <td>{memo}</td>
          <td className="text-right">{formattedAmount}</td>
          <td className="text-right"></td>
        </tr>

        <tr>
          <td>{formattedDate}</td>
          <td>{trx_code}</td>
          <td>{coa}</td>
          <td>{memo}</td>
          <td className="text-right"></td>
          <td className="text-right">{formattedAmount}</td>
        </tr>
      </Fragment>
    );
  }

  return <Fragment />;
}
const PaymentDeposit = () => {
  const tracking = useCoaByCode("LA07");
  const asset = useCoaByCode("LA09");

  const { control } = useFormContext<PaymentBillServiceSchema>();
  const memo = useWatch({ control, name: "memo" });
  const deposit_amount = useWatch({ control, name: "deposit_amount" });
  const transaction_date = useWatch({ control, name: "transaction_date" });
  const trx_code = useWatch({ control, name: "trx_code" });

  const formattedDate = moment(transaction_date).format("DD/MM/YYYY");
  const formattedAmount = convertNumber(deposit_amount).intoCurrency;

  if (deposit_amount) {
    return (
      <Fragment>
        <tr>
          <td>{formattedDate}</td>
          <td>{trx_code}</td>
          <td>{tracking.data}</td>
          <td>{memo}</td>
          <td className="text-right">{formattedAmount}</td>
          <td className="text-right"></td>
        </tr>

        <tr>
          <td>{formattedDate}</td>
          <td>{trx_code}</td>
          <td>{asset.data}</td>
          <td>{memo}</td>
          <td className="text-right"></td>
          <td className="text-right">{formattedAmount}</td>
        </tr>
      </Fragment>
    );
  }

  return <Fragment />;
}
const Total = () => {
  const { control } = useFormContext<PaymentBillServiceSchema>();
  const deposit_amount = useWatch({ control, name: "deposit_amount" });
  const payment_amount = useWatch({ control, name: "payment_amount" });

  const formattedAmount = convertNumber(deposit_amount + payment_amount).intoCurrency;

  return (
    <tr>
      <td colSpan={4} />
      <td className="text-right">{formattedAmount}</td>
      <td className="text-right">{formattedAmount}</td>
    </tr>
  );
}

JournalList.PaymentAccount = PaymentAccount;
JournalList.PaymentDeposit = PaymentDeposit;
JournalList.Total = Total;
